import { ModalProvider } from "./components/context/ModalContext";
import { PDFProvider } from "./components/context/PDFContext";
import { DataProvider } from "./components/context/DataContext";
import PopupModal from "./components/PopupModal/PopupModal";

import './App.css';

import Content from './layout/Content/Content';

function App() {

  
  return (
      <DataProvider>
        <PDFProvider>
          <ModalProvider>
            <Content />
            <PopupModal />
          </ModalProvider>
        </PDFProvider>
      </DataProvider>
  );
}

export default App;
